import { Service } from "../shared/Service";

export class TipoDiagnosticoFormularioService extends Service {

    constructor() {
        super('v1/tipoDiagnosticoFormulario');
    }
}